<div class="modal-dialog" [attr.role]="'document'">
  <div class="modal-content">
    <div class="col-sm-12 coldx">

      <div class="row">
        <div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
             [labelInput]="'Identificativo'" [valueInput]="documento.identificativoDocumento">
        </div>
        <div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
             [labelInput]="'Segnatura protocollo'" [valueInput]="documento.segnaturaProtocollo">
        </div>
        <div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
             [labelInput]="'Nome file'" [valueInput]="documento.nomeFile">
        </div>
        <div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
             [labelInput]="'Formato'" [valueInput]="documento.formato">
        </div>
      </div>
      <div class="row">
        <div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
             [labelInput]="'Modalità formazione'" [valueInput]="documento.modalitaFormazione">
        </div>
        <div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
             [labelInput]="'Stato documento'" [valueInput]="documento.statoDocumento">
        </div>
        <div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
             [labelInput]="'Versione documento'" [valueInput]="documento.versioneDocumento">
        </div>
        <div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
             [labelInput]="'Tipo flusso'" [valueInput]="documento.tipoFlusso">
        </div>
      </div>
      <div class="row">
        <div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
             [labelInput]="'Tipo registro'" [valueInput]="documento.tipoRegistro">
        </div>
        <div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
             [labelInput]="'Tipologia documentale'" [valueInput]="documento.tipologiaDocumentale">
        </div>
        <div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'boolean'"
             [labelInput]="'Firmato digitalmente'" [valueInput]="documento.firmatoDigitalmente">
        </div>
        <div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'boolean'"
             [labelInput]="'Sigillato elettronicamente'" [valueInput]="documento.sigillatoElettronicamente">
        </div>
      </div>
      <div class="row">
        <div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'boolean'"
             [labelInput]="'Marcatura temporale'" [valueInput]="documento.marcaturaTemporale">
        </div>
        <div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'boolean'"
             [labelInput]="'Riservato'" [valueInput]="documento.riservato">
        </div>
        <div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
             [labelInput]="'Data creazione'" [valueInput]="documento.dataCreazione | date:'dd/MM/yyyy'">
        </div>
        <div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
             [labelInput]="'Data modifica'" [valueInput]="documento.dataModifica | date:'dd/MM/yyyy'">
        </div>
      </div>
      <div class="row">
        <div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'boolean'"
             [labelInput]="'Conformita copia su supporto informatico'" [valueInput]="documento.conformitaCopiaSuSupportoInformatico">
        </div>
        <div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'text'"
             [labelInput]="'Impronta documento'" [valueInput]="documento.improntaDocumento">
        </div>
      </div>
      <div class="row">
          <div labelTextInput class="col-sm-9 bloccodati" [typeLabel]="'text'"
               [labelInput]="'Soggetti'" [valueInput]="getSoggettiString()">
          </div>
          <div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
               [labelInput]="'Numero allegati'" [valueInput]="documento.numeroAllegati">
          </div>
      </div>
      <ng-container *ngIf="documento.allegati?.length">
        <div class="row">
          <div class="col-sm-12">
            <h5 style="font-weight: bold;">Allegati</h5>
          </div>
        </div>

        <div class="row" *ngFor="let allegato of documento.allegati">
          <div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'text'"
              [labelInput]="'Identificativo Allegato'" [valueInput]="allegato.identificativoDocumento">
          </div>
          <div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'text'"
              [labelInput]="'Nome Allegato'" [valueInput]="allegato.nomeAllegato">
          </div>
        </div>
    </ng-container>
  </div>
</div>
